import { YfmHeadingAttr, headingNodeName } from './const';
import { getNodeAttrs } from './utils';
const DEFAULT_PLACEHOLDER = (node) => 'Heading ' + node.attrs[YfmHeadingAttr.Level];
export { YfmHeadingAttr } from './const';
/** YfmHeading extension needs markdown-it-attrs plugin */
export const YfmHeadingSpecs = (builder, opts) => {
    builder.addNode(headingNodeName, () => {
        var _a, _b, _c;
        return ({
            spec: {
                attrs: {
                    [YfmHeadingAttr.Id]: { default: '' },
                    [YfmHeadingAttr.Level]: { default: 1 },
                    [YfmHeadingAttr.DataLine]: { default: null },
                },
                content: '(text | inline)*',
                group: 'block',
                defining: true,
                selectable: true,
                parseDOM: [
                    { tag: 'h1', getAttrs: getNodeAttrs(1) },
                    { tag: 'h2', getAttrs: getNodeAttrs(2) },
                    { tag: 'h3', getAttrs: getNodeAttrs(3) },
                    { tag: 'h4', getAttrs: getNodeAttrs(4) },
                    { tag: 'h5', getAttrs: getNodeAttrs(5) },
                    { tag: 'h6', getAttrs: getNodeAttrs(6) },
                ],
                toDOM(node) {
                    const id = node.attrs[YfmHeadingAttr.Id];
                    const lineNumber = node.attrs[YfmHeadingAttr.DataLine];
                    return [
                        'h' + node.attrs[YfmHeadingAttr.Level],
                        {
                            id: id || null,
                            [YfmHeadingAttr.DataLine]: lineNumber,
                        },
                        0,
                        // [
                        //     'a',
                        //     {
                        //         href: `#${node.attrs[YfmHeadingAttr.Id]}`,
                        //         class: 'yfm-anchor',
                        //         'aria-hidden': 'true',
                        //         contenteditable: 'false',
                        //     },
                        // ],
                        // ['span', 0],
                    ];
                },
                placeholder: {
                    content: (_c = (_b = (_a = builder.context.get('placeholder')) === null || _a === void 0 ? void 0 : _a.heading) !== null && _b !== void 0 ? _b : opts.headingPlaceholder) !== null && _c !== void 0 ? _c : DEFAULT_PLACEHOLDER,
                    alwaysVisible: true,
                },
            },
            fromYfm: {
                tokenSpec: {
                    name: headingNodeName,
                    type: 'block',
                    getAttrs: (token) => {
                        if (token.type.endsWith('_close'))
                            return {};
                        const attrs = Object.fromEntries(token.attrs || []);
                        // if (!attrs[YfmHeadingAttr.Id]) {
                        //     // calculate id if it was not specified
                        //     // tokens[index + 1] is child inline token
                        //     attrs[YfmHeadingAttr.Id] = slugify(tokens[index + 1].content);
                        // }
                        // attrs have id only if it explicitly specified manually
                        return Object.assign({ [YfmHeadingAttr.Level]: Number(token.tag.slice(1)) }, attrs);
                    },
                },
            },
            toYfm: (state, node) => {
                state.write(state.repeat('#', node.attrs[YfmHeadingAttr.Level]) + ' ');
                state.renderInline(node);
                const anchor = node.attrs[YfmHeadingAttr.Id];
                if (anchor /*&& anchor !== node.firstChild?.textContent*/) {
                    state.write(` {#${anchor}}`);
                }
                state.closeBlock(node);
            },
        });
    });
};
